export const RiskDot = ({ risk, size = 10 }) => {
  if (!risk || risk.level === "bajo") return null;
  const color = risk.level === "alto" ? "#DC2626" : "#D97706";
  const label = risk.level === "alto" ? "Riesgo alto de olvido" : "Atención";
  return (
    <span
      title={`${label}: ${risk.reasons.join(" · ")}`}
      aria-label={label}
      data-testid={`risk-dot-${risk.level}`}
      className="inline-flex items-center shrink-0"
    >
      <span
        className="rounded-full ring-2 ring-white"
        style={{ width: size, height: size, backgroundColor: color }}
      />
    </span>
  );
};
